import ShieldHalfFill from './ShieldHalfFill';

export default ShieldHalfFill;
